"use client";

import RequireAuth from "@/shared/components/RequireAuth";

export default function TenderLayout({ children }: { children: React.ReactNode }) {
  return <RequireAuth>{children}</RequireAuth>;
}
